import { Link } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { fileUrl } from "@/lib/api";

export const Logo = ({ light = false, className = "" }) => {
  const { config } = useApp();
  const logoId = config?.branding?.logo_file_id;
  return (
    <Link to="/" data-testid="brand-logo-link" className={`flex shrink-0 items-center gap-3 whitespace-nowrap ${className}`}>
      {logoId ? (
        <img src={fileUrl(logoId)} alt="Nillo Ruídos" className="h-10 w-auto object-contain" data-testid="brand-logo-img" />
      ) : (
        <span className="flex items-center gap-2" data-testid="brand-logo-text">
          <img src="/img/logo-nillo.jpg" alt="Equipe Nillo Ruídos" className="h-12 w-12 rounded-full object-cover ring-1 ring-red-700/60" data-testid="brand-logo-default-img" />
          <span className="leading-none">
            <span className={`block font-heading text-lg font-bold tracking-wider ${light ? "text-slate-900" : "text-white"}`}>
              NILLO <span className="text-[#DC2626]">RUÍDOS</span>
            </span>
            <span className={`block font-mono text-[9px] uppercase tracking-[0.25em] ${light ? "text-slate-500" : "text-slate-400"}`}>
              Excelência em conforto
            </span>
          </span>
        </span>
      )}
    </Link>
  );
};
